// Home room state, Schema v1-sprint (92 §3.2). Append only.
import { schema, t } from '@colyseus/schema';
import { Player } from './area';
export const Placement = schema({
    def: t.uint16().default(0), // item net id (ItemDef.netId)
    x: t.uint8().default(0),
    y: t.uint8().default(0),
    rot: t.uint8().default(0), // quarter turns 0..3
}, 'Placement');
export const HomeState = schema({
    players: t.map(Player), // key = eidKey(eid), at most HOME_MAX_CLIENTS
    placements: t.map(Placement), // key = placement id
    version: t.uint32().default(0), // homes.version after the last committed build batch
}, 'HomeState');
